
















































import Vue from "vue";
import configuration, { AppConfiguration, loadConfiguration } from "../models/Configuration";

interface Data {
  configuration: AppConfiguration;
  showUp: boolean;
  showDown: boolean;
  ticking: boolean;
  resizeObserver: ResizeObserver | null;
}

interface Methods {
  onScroll(): void;
  update(): void;
  scrollTo(target: "top" | "bottom"): void;
}

interface Computed {
  enabled: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  data: () => ({
    configuration,
    showUp: false,
    showDown: false,
    ticking: false,
    resizeObserver: null,
  }),

  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onScroll, { passive: true });

    // A tartalom dinamikusan változhat (adat betöltése, sorok ki-/becsukása),
    // ami görgetés/ablakméretezés nélkül módosítja a görgethető magasságot.
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => this.onScroll());
      this.resizeObserver.observe(document.body);
    }

    if (!configuration.isLoaded) {
      loadConfiguration();
    }

    this.$nextTick(() => {this.update();});
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onScroll);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },

  computed: {
    enabled() {
      return this.configuration.sysParams.isPageTopDownVisible;
    },
  },

  methods: {
    onScroll() {
      // Throttle: görgetésenként legfeljebb egyszer számolunk újra (egy frame).
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    },

    update() {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop || 0;
      const max = doc.scrollHeight - doc.clientHeight;
      const threshold = 100;

      this.showUp = scrollTop > threshold;
      this.showDown = max > threshold && scrollTop < max - threshold;
    },

    scrollTo(target) {
      const top = target === "top" ? 0 : document.documentElement.scrollHeight;
      window.scrollTo({ top, behavior: "smooth" });
    },
  },
});
